// Source : https://mui.com/material-ui/react-autocomplete/#virtualization
import * as React from 'react';
import { VariableSizeList, ListChildComponentProps } from 'react-window';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

const LISTBOX_PADDING = 8; // px

function renderRow(props: ListChildComponentProps) {
  const { data, index, style } = props;
  const dataSet = data[index];

  const inlineStyle = {
    ...style,
    top: (style.top as number) + LISTBOX_PADDING,
    whiteSpace: 'nowrap'
  };

  if(dataSet[1]?.key === 'dontSeeYourBuildingButton'){
    return (
      <Box component="li" {...dataSet[0]} style={{...inlineStyle}} padding={8} sx={
        {
          "&.MuiAutocomplete-option.Mui-focused ": {
            backgroundColor: "rgba(61, 177, 87, 0.12) !important",
          },
        }
      }>
        {dataSet[1].button}
      </Box>
    )
  }

  return (
    <Typography component="li" {...dataSet[0]} style={inlineStyle} variant="body1" padding={8}>
      {dataSet[1].label} <br />
      {dataSet[1].address}
    </Typography>
  );
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef<HTMLDivElement>((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data: any) {
  const ref = React.useRef<VariableSizeList>(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const MuiListbox = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLElement>
>(function MuiListbox(props, ref) {
  const { children, ...other } = props;
  const itemData: React.ReactChild[] = [];
  (children as React.ReactChild[]).forEach(
    (item: React.ReactChild & { children?: React.ReactChild[] }) => {
      itemData.push(item);
      itemData.push(...(item.children || []));
    },
  );

  const itemCount = itemData.length;
  const itemSize = 70;
  const endOfListButtonSize = 45;

  const getChildSize = (itemData: any) : number => {
    return itemData[1]?.key === 'dontSeeYourBuildingButton' ? endOfListButtonSize : itemSize
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    const listSizeWithoutButton = (itemCount - 1) * itemSize
    return listSizeWithoutButton + endOfListButtonSize;
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

export default MuiListbox;